import { render, staticRenderFns } from "./yardim.vue?vue&type=template&id=21d1b2a3&"
import script from "./yardim.vue?vue&type=script&lang=js&"
export * from "./yardim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports